import type { LayerInfo, IExtremeMap } from 'src/models';
import type { User } from 'src/models/user';
import type { GeoItemsMeta, GeoItemMeta, GeoItemMetaComment } from 'src/models/geoItem';
import type { MastersContext } from 'src/models/master';

interface Options {
  useGIManager: boolean;
  user?: User;
  masters?: MastersContext;
}

export function isGeoItemMetaComment(meta: GeoItemMeta): meta is GeoItemMetaComment {
  return meta.name === 'comment';
}

export async function getGeoItemMeta(layerInfoList: LayerInfo[], options: Options = {useGIManager: false}): Promise<Record<string, GeoItemMeta>> {
  const masters = options.masters;
  const items = await Promise.all(layerInfoList.map(async(info): Promise<GeoItemMeta | null> => {
    try {
      const tmpStr = info.name[0].toUpperCase() + info.name.slice(1);
      let giManager = null;
      if (options.useGIManager && masters) {
        const GIMgrClass = (await import(`src/lib/geo_item/GI${tmpStr}Manager`)).default;
        giManager = new GIMgrClass({
          user: options.user,
          carKindMap: masters.lov.carKindMap,
          shareScopeMap: masters.lov.shareScopeMap,
          commentTypeMap: masters.comment.commentTypeMap,
        });
      }
      const EMLayerMgrClass = (await import(`src/lib/extreme_map/EM${tmpStr}LayerManager`)).default;
      const layerManager = new EMLayerMgrClass({ dataName: info.name, giManager });
      return {
        name: info.name,
        dispName: info.dispName,
        manager: giManager,
        layerManager: layerManager,
        hideToggleCheckbox: !!info.hideToggleCheckbox,
        isCreatable: !!info.isCreatable,
        isTabPanel: !!info.isTabPanel,
        tabLabel: info.tabLabel || '',
      };
    } catch (e) {
      console.warn(`failure loading geo item manager for '${info.name}'`);
      console.warn(e);
      return null;
    }
  }));

  const ret: Record<string, GeoItemMeta> = {};
  items.forEach(item => {
    if (item) ret[item.name] = item;
  });

  return ret;
}

export function syncGeoItemWithParent(
  child: GeoItemsMeta,
  parent: GeoItemsMeta,
  extremeMap: IExtremeMap): void {
  for (const [dataName, metaItem] of Object.entries(child.map)) {
    const parentMetaItem = parent.map[dataName];
    if (!parentMetaItem) { continue; }
    if (parent.show[dataName]) {
      const data = Object.values(parentMetaItem.layerManager.getResourceMap());
      extremeMap.showDataLayer(metaItem, data);
    } else {
      extremeMap.removeDataLayer(metaItem.name);
    }
  }
}
